import { apiClient } from "./apiClient";

const endpoint = "margins";

const getMargins = (includeChildren?: boolean) =>
  apiClient(`${endpoint}`).fetchWithParams(`?includeChildren=${includeChildren ?? false}`);

const getBetaCubes = (marginId: number) =>
  apiClient(`${endpoint}/betaCubes`).fetchWithParams(`?marginId=${marginId}`);

const updateBetas = (betaCubes: any[], name: string, marginId: number = 0) =>
  apiClient(`${endpoint}/betaCubes`).put({ marginId, name, betaCubes });

const createMargin = (
  name: string,
  betaCubes: any[],
  commodityId: number,
  businessTypeId: number,
) => apiClient(`${endpoint}/create`).post({ name, betaCubes, commodityId, businessTypeId });

const deleteMargin = (marginId: number) => apiClient(endpoint).delete(marginId);

export default {
  getMargins,
  getBetaCubes,
  updateBetas,
  createMargin,
  deleteMargin,
};
